// extracted by mini-css-extract-plugin
module.exports = {"pill":"CountPill_pill__33cYf"};